<template>
    <div class="ml-4">
            <h1 class="text-muted mb-4">
                <vue-fontawesome class="mr-2" icon="bar-chart"></vue-fontawesome>
                <router-link class="ml-2 text-decoration-none" to="/reports">
                    <i class="ml-2 arrow left" style="height:25px;width:25px"></i>
                    Reports
                </router-link> 
                / Sales Per User
            </h1>

        <section>    
            <div class="d-flex justify-content-between">
                <div>
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">
                                                        
                                Graphs
                            </a>
                        </li>                               							
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="pills-raw-data-tab" 
                                data-toggle="pill" 
                                href="#pills-raw-data" 
                                role="tab" 
                                aria-controls="pills-raw-data" 
                                aria-selected="true">
                                                        
                                Raw Data
                            </a>
                        </li>
                    </ul>                  
                </div>              
            </div>	
            <div class="d-flex ">                										
                <div class="form-group d-flex">
                    <label class="p-2">From:</label>
                    <input type="date" name="bday" max="3000-12-31" 
                    min="1000-01-01" class="form-control" v-model="from_date"> 
                </div> 
                <div class="form-group d-flex">
                    <label class="p-2">To:</label>
                    <input type="date" name="bday" max="3000-12-31" 
                    min="1000-01-01" class="form-control" v-model="to_date"> 
                </div> 
                <div class="ml-2" @click="getReport()">
                    <button class="btn btn-outline-success">
                        <span v-if = "getting_reports" class="spinner-border spinner-border-sm"></span>
                        Run reports
                    </button>
                </div>						
            </div>            
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" 
                    id="pills-home" 
                    role="tabpanel" 
                    aria-labelledby="pills-home-tab">                           
                    <div class="" v-if="reports">
                        <barchart v-if="render_graph" :data="graph_data" :options="options" class="col-12"/>
                        <hr>
                        <doughnutChart v-if="render_graph" :data="graph_data" class="col-lg-8 p-2"/>
                    </div>                   
                </div>     
                <div class="tab-pane fade" 
                    id="pills-raw-data" 
                    role="tabpanel" 
                    aria-labelledby="pills-raw-data-tab">                    
                    <table class="table table-borderless">													
                        <thead>
                            <tr>												
                            <th scope="col">User</th>
                            <th scope="col">Sale</th>                            
                            </tr>
                        </thead>                                                               
                        <tbody v-if="reports">
                            <tr v-for="(report,index) in reports.data" :key="index">												
                                <td>{{report.user.name}}</td>
                                <td>{{report.sales | intcomma}}</td>                            														
                            </tr>	
                            <tr>
                                <td class="font-weight-bold">Total</td>
                                <td class="font-weight-bold">{{reports.total | intcomma}}</td>
                            </tr>											
                        </tbody>
                    </table>
                </div>                              
            </div>
            
        </section>
    </div>
</template>
<script>
import barchart from '@/components/charts/bar.vue'
import doughnutChart from '@/components/charts/doughnut.vue'
export default {
    name: 'reportDetail',
    components: { doughnutChart,barchart},
    data(){
        return{         
            getting_reports:false,   
            from_date: null,
            to_date: null,
            url:null,
            reports:null,
            render_graph: false,
            options:{
                responsive: true,
                maintainAspectRatio: false
            },
            graph_data:{
                labels: [],
                datasets: [
                    {
                        label: "Bar chart",                        
                        labels: [],
                        backgroundColor: [],
                        data: []
                    }
                ]
            }            
        }
    },    
    mounted(){
        this.from_date = this.$moment().subtract(0, 'days').format('YYYY-MM-DD')
        this.to_date = this.$moment().format('YYYY-MM-DD')
        this.getReport()            
    },
    computed:{     
        account_switched(){
            return this.$store.state.account_switch_count
        }
    },
    watch:{
        account_switched: function(){
            this.getReport()
        },
        reports: function(){            
            if (this.reports){   
                this.render_graph = false            
                //reset graph data to original
                this.graph_data = {
                    labels: [],
                    datasets: [
                        {                                                    
                            labels: [],
                            backgroundColor: [],
                            data: []
                        }
                    ]
                }                        
                //update graph data       
                for (var i in this.reports.data){
                    var data = this.reports.data[i]
                    this.graph_data.labels.push(data.user.name)

                    this.graph_data.datasets[0].backgroundColor.push("#"+((1<<24)*Math.random()|0).toString(16))
                    this.graph_data.datasets[0].labels.push(data.user.name)
                    this.graph_data.datasets[0].data.push(data.sales)
                }
                this.render_graph = true
            }
        }
    },
    methods:{		
        //get_products
        getReport: function(){    
            this.getting_reports = true        
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/sales_per_user/${this.from_date}/${this.to_date}`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{
                this.getting_reports = false
                this.reports = response.data            
            }).catch((err)=>{
                this.getting_reports = false
                this.$emit('alert',err)
            })
        },
    }
}
</script>
            